export const TOO_MANY_REQUESTS_STATUS = 429;
